module.exports = __webpack_public_path__ + "img/frankfurt_airport.1bd99013.png";